import {
	FileExchangeRoutes,
	type ImportExecutionChangeListResponse,
	type ImportExecutionDetailDTO,
	type ImportExecutionLinkDTO,
	type ImportExecutionListResponse,
} from '@today/types'
import { apiClient } from './api.client'

/**
 * Import monitoring API client (TO-399; TO-632 merged runtime surface
 * `/imports/{id}`). An empty page is `200 {data:[],total:0}` (AD-21.7), so a list
 * read returns its page object; the download links are requested on demand and
 * never cached.
 */

const withId = (route: string, id: string) => route.replace('{id}', encodeURIComponent(id))

/** The paged body; `null` only if the response carries no body at all. */
const pageOrNull = <T>(response: { data: T | '' }): T | null => (response.data === '' ? null : (response.data as T))

export const importMonitoringService = {
	list: async (params: Record<string, string>) =>
		pageOrNull(
			await apiClient.get<ImportExecutionListResponse | ''>(FileExchangeRoutes.listImportExecutions, { params }),
		),
	get: async (id: string) =>
		(await apiClient.get<ImportExecutionDetailDTO>(withId(FileExchangeRoutes.getImportExecution, id))).data,
	changes: async (id: string, params: Record<string, string>) =>
		pageOrNull(
			await apiClient.get<ImportExecutionChangeListResponse | ''>(
				withId(FileExchangeRoutes.listImportExecutionChanges, id),
				{ params },
			),
		),
	errorsReportLink: async (id: string) =>
		(await apiClient.get<ImportExecutionLinkDTO>(withId(FileExchangeRoutes.getImportErrorsReportLink, id))).data,
	originalFileLink: async (id: string) =>
		(await apiClient.get<ImportExecutionLinkDTO>(withId(FileExchangeRoutes.getImportOriginalFileLink, id))).data,
}
